import { render, staticRenderFns } from "./GTextareaCsvForm.vue?vue&type=template&id=6cdfc702&scoped=true&"
import script from "./GTextareaCsvForm.vue?vue&type=script&lang=ts&"
export * from "./GTextareaCsvForm.vue?vue&type=script&lang=ts&"
import style0 from "./GTextareaCsvForm.vue?vue&type=style&index=0&id=6cdfc702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdfc702",
  null
  
)

export default component.exports